
(function ($) {
    $.loginAsync = function (el, options) {
        // To avoid scope issues, use 'base' instead of 'this'
        // to reference this class from internal events and functions.
        var base = this;

        // Access to jQuery and DOM versions of element
        base.$el = $(el);
        base.el = el;

        // Add a reverse reference to the DOM object
        base.$el.data("loginAsync", base);

        base.showResult = function(callback) {
            $(base.options.loginFormId + ' .loginLoading').fadeOut('fast', function () {
                $(base.options.loginFormId + ' .spinner-container').spin(false);
                $(base.options.loginFormId + ' .loginFieldset').fadeIn('fast', function () {
                    $(base.options.errorObject).show();
                    if (typeof callback == "function")
                        callback();
                });
            });
        };
        base.showLoading = function (callback) {
            $(base.options.errorObject).hide();
            $(base.options.loginFormId + ' .loginFieldset').fadeOut('fast', function () {
                $(base.options.loginFormId + ' .spinner-container').spin();
                $(base.options.loginFormId + ' .loginLoading').fadeIn('fast', function () {
                    if (typeof callback == "function")
                        callback();
                });
            });
        };
        base.checkResult = function(result) {
            if (result !== "" && result === "okbutbadpassword") {
                if (base.options.redirectBadPasswordTo.length > 0) {
                    if (window.parent !== window.top) {
                        window.parent.location.href = base.options.redirectBadPasswordTo;
                    } else {
                        window.location.href = base.options.redirectBadPasswordTo;
                    }
                }
            } 
            else if (result !== "" && result === "ok") {
                if (typeof(base.options.loginSuccessful) == "function") {
                    base.options.loginSuccessful(base);
                }
                else if (base.options.redirectTo.length > 0) {
                    if (window.parent !== window.top) {
                        window.parent.location.href = base.options.redirectTo;
                    } else {
                        window.location.href = base.options.redirectTo;
                    }
                }
                else {
                    $(base.options.errorObject).html("Bei der Anmeldung ist ein Fehler aufgetreten bitte versuchen Sie es noch einmal.");
                    base.showResult();
                }
            } else {
                $(base.options.errorObject).html(result);

                base.showResult(function () {
                    $(base.options.passwordField).val("");
                   
                    if ($(base.options.usernameField).val() !== "")
                        $(base.options.passwordField).focus();
                    else
                        $(base.options.usernameField).focus();
                });
            }
        };

        base.init = function () {
            base.options = $.extend({}, $.loginAsync.defaultOptions, options);

            $(base.options.usernameField + ", " + base.options.passwordField).on("keydown", function (a) {
                if (a.which === 13) {
                    a.stopImmediatePropagation();
                    a.preventDefault();
                    base.$el.click();
                }
            });


            base.$el.on("click", function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();
                

                try {
                    webkit.messageHandlers.callbackHandler.postMessage("B24AppOnLogin");
                } catch(error) {
                }

                try {
                    B24AppJavascriptInterface.onLogin();
                } catch (error) {

                }

                base.showLoading(function() {
                    var user = $(options.usernameField).val();
                    var pass = $(options.passwordField).val();

                    // if the password contains a '&', replace it with utf-8 encoding character '%26' | see: https://www.w3schools.com/tags/ref_urlencode.asp
                    pass = pass.replace("&", "%26");

                    $.ajax({
                        type: "POST",
                        async: true,
                        url: options.serviceUserUrl,
                        data: "action=userlogin&user=" + user + "&password=" + pass,
                        success: base.checkResult
                    });
                });

                return false;
            });

            $("form").on('submit', function() {
                $(options.usernameField).prop("disabled", true);
                $(options.passwordField).prop("disabled", true);
            });
        };

        base.init();
    };

    $.loginAsync.defaultOptions = {
        serviceUserUrl: "",
        usernameField: "#username",
        passwordField: "#password",
        errorObject: "#errorMessage",
        loginFormId: "#loginBox",
        redirectTo: "",
        redirectBadPasswordTo: "",
        loginSuccessful: null,
        sender: null
    };

    $.fn.loginAsync = function (options) {
        return this.each(function () {
            (new $.loginAsync(this, options));
        });
    };

})(jQuery);

var lastSelector;

$(function () {
    $(document).on("click", ".loginButton", function (a) {

        a.stopImmediatePropagation();
        a.preventDefault();

        $("#loginBox").show().css("opacity", "0");
        $("#loginBox").css("left", ($(this).offset().left + $(this).outerWidth()) - $("#loginBox").outerWidth());
        $("#loginBox").css("top", $(this).offset().top + $(this).outerHeight());

        loginButtonPlugin.data("loginAsync").options.redirectTo = $(this).attr("href");
        loginButtonPlugin.data("loginAsync").options.sender = $(this);
        
        $("#loginBox").css("opacity", "1");

        setTimeout(function () {
            $("#username").focus();
        }, 100);

        if (lastSelector != undefined && $(this).attr("id") !== lastSelector && $(this).hasClass("active"))
            return false;

        $(this).toggleClass("active");
        lastSelector = $(this).attr("id");

        return false;
    });
    $(".loginForm").on("mouseup", function () { return false });
    $(this).on("mouseup", function (a) {
        if ($(a.target).hasClass("loginButton")) {
            return;
        }

        $(".loginButton").removeClass("active");
        $(".loginBox").fadeOut();
    });
});

